'use client'

import * as React from 'react'
import NumberFlowComp from '@number-flow/react'

import cn from '@config/tailwind/cn'

interface NumberFlowProps extends Omit<React.ComponentProps<typeof NumberFlowComp>, 'value'> {
  value: number
}

export function NumberFlow({ value, ...props }: NumberFlowProps) {
  const [finalValue, setFinalValue] = React.useState(0)

  React.useEffect(() => {
    setFinalValue(value)
  }, [value])

  return (
    <NumberFlowComp
      value={finalValue}
      animated
      className={cn('ui:font-bold ui:md:text-3xl ui:text-2xl', props.className)}
      locales='id-ID'
      {...props}
    />
  )
}
